module.exports = __webpack_public_path__ + "img/22.3.TP.7061ec37.png";